module.exports = __webpack_public_path__ + "static/img/504_phase_function_Paper_PointsHejduk_Prediction.729708a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/504_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 2zIa
// module chunks = 0